export default
  prettyPhone: (string) ->
    if !string
      return ''
    numbers = string.replace /\D/g, ''
    char = 0: '(', 3: ') ', 6: '-'
    phone = ''
    for num, i in numbers
      phone += (char[i] || '') + num
    return phone.substr 0, 16
  rawPhone: (string) ->
    if !string
      return ''
    digits = string.replace(/[^0-9]/g,'').trim()
    if !digits
      return ''
    return digits
  capitalize: (string) ->
    if !string
      return ''
    return string.charAt(0).toUpperCase() + string.slice 1
  money: (string) ->
    if !string
      return '0.00'
    if string == undefined
      return '0.00'
    return Number(string).toFixed(2)
  timeTill: (numbers) ->
    if !numbers
      return 'now.'
    if numbers < 1000
      return 'now.'
    if Number.isNaN(numbers)
      return 'now.'
    string = 'in'
    milliseconds = parseInt(numbers)
    hours = Math.floor(milliseconds / 3600000)
    minutes = Math.floor((milliseconds - (hours * 3600000)) / 60000)
    seconds = Math.floor((milliseconds - (hours * 3600000) - (minutes * 60000)) / 1000)
    if hours > 0
      string = string + ' ' + hours + ' hour'
      if hours > 1
       string = string + 's'
      if minutes > 0
        string = string + ', '
    if minutes > 0
      string = string + ' ' + minutes + ' minute'
      if minutes > 1
        string = string + 's'
      if seconds > 0
        string = string + ', '
    string = string + ' ' + seconds + ' second'
    if seconds > 1
      string = string + 's'
    if seconds == 0
      string = string + 's'
    string = string + '.'
    return string
  couponDay: (string) ->
    if !string
      return ''
    return string.substring(0, 3)
  couponTime: (string) ->
    if !string
      return ''
    return string.substring(0, 5) + " " + string.substring(9)
